"use strict";

angular.module("vendor")
.component("customerDetails", {
    bindings: {
        instance: "<"
    },
    templateUrl: require("./customer-details.component.html"),
    controller: customerDetailsController,
    controllerAs: "customerDetailsCtrl"
});

function customerDetailsController(ModalService ) {
    var _this = this;

    this.openDetails = function() {
        ModalService.showModal({
            templateUrl: require("./customer-details.modal.html"),
            controller: "CustomerDetailsController",
            controllerAs: "customerDetailsCtrl",
            inputs: {
                $attrs: {
                    instance: _this.instance
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
        });
    };
}



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/customer-details-modal/customer-details.component.js
// module id = 838
// module chunks = 0